<div class="grid add-system-area-pgms-grid">
    <div id='asp-background' class="group-background"></div>
    <div id='asp-pgm-list'>
        <div class="asp-pgm-item" *ngFor='let pgm of getPgms()' (click)='pgmClick(pgm.queue_no)'>
            <div class='asp-pgm-icon' [inlineSVG]="'assets/images/pgm-general-icon.svg'"></div>
            <div class='asp-pgm-number'>{{pgm.queue_no}}</div>
            <app-button-double-line-arrow class='asp-pgm-text' [firstLine]="trans('systems.labels.output')" [secondLine]="pgm.name"></app-button-double-line-arrow>
        </div>
    </div>
</div>